// extracted by mini-css-extract-plugin
export default {"container":"add-to-favorites_container__29h28","isAdded":"add-to-favorites_isAdded__22TPt","event":"add-to-favorites_event__2asm6","isDark":"add-to-favorites_isDark__3pnIr"};